import { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import InvoiceFilterModal from "../modals/invoice/InvoiceFilterModal";
import { useAuthStore } from "../../store/auth.store";
import number_format from "../../utils/number_format";
import { useTranslation } from "../../hooks/useTranslation";

export function LoanFilterActual({ setFilter, filter }) {
  const { t } = useTranslation();
  const deleteFromFilter = (key) => {
    if (key === "current_state_id") {
      setFilter({
        ...filter,
        current_state_id: [],
      });
    } else {
      setFilter({
        ...filter,
        [key]: null,
      });
    }
  };

  const deletableFilters = [
    ["loan_from_ge", t("loans.loanFrom") + " " + t("common.from"), "date"],
    ["loan_from_le", t("loans.loanTo") + " " + t("common.to"), "date"],
    ["create_date_ge", t("loans.requestDate") + " " + t("common.from"), "date"],
    ["create_date_le", t("loans.requestDate") + " " + t("common.to"), "date"],
    ["fulltext", t("common.fulltext"), "string"],
    ["current_state_id", t("deals.currentState"), "state"],
  ];

  let isFilterFill = false;

  deletableFilters.forEach((deletableFilter) => {
    if (deletableFilter[0] in filter && filter[deletableFilter[0]]) {
      isFilterFill = true;
    }
  });

  if (!isFilterFill) {
    return <></>;
  }

  const stateNames = {
    [-1]: t("loans.cancelled"),
    [1]: t("loans.registered"),
    [2]: t("loans.approved"),
  };

  return (
    <div className="d-lg-flex gap-2 py-3 border-bottom">
      {deletableFilters.map(
        (deletableFilter, key) =>
          deletableFilter[0] in filter &&
          filter[deletableFilter[0]] &&
          (!Array.isArray(filter[deletableFilter[0]]) ||
            (Array.isArray(filter[deletableFilter[0]]) &&
              filter[deletableFilter[0]].length > 0)) && (
            <>
              <div className="btn-group" key={key}>
                <button className="btn btn-sm btn-secondary">
                  {deletableFilter[1]}:&nbsp;
                  <strong>
                    {deletableFilter[2] === "string" &&
                        filter[deletableFilter[0]]}

                    {deletableFilter[2] === "date" &&
                      new Date(filter[deletableFilter[0]]).toLocaleDateString()}

                    {deletableFilter[2] === "number" &&
                      number_format(filter[deletableFilter[0]], 2, ",", ".")}

                    {deletableFilter[2] === "state" &&
                        filter[deletableFilter[0]].map(
                            (state, sindex) =>
                                (sindex > 0 ? ", " : "") + stateNames[state]
                        )}
                  </strong>
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => deleteFromFilter(deletableFilter[0])}
                >
                  <i className="ki-solid ki-trash text-white"></i>
                </button>
              </div>
            </>
          )
      )}
    </div>
  );
}
